/**
 * Отладочные строки в консоль — только когда их попросили.
 *
 * ⚠️ ЭТО НЕ КОСМЕТИКА. В консоли игрока висело больше четырёхсот строк: список
 * всех загруженных рыб с числом треугольников, разбор каждой поклёвки, каждый
 * подключившийся рыболов, каждое озеро в журнале. Среди этого шума настоящая
 * ошибка не находится ни глазами, ни поиском — а именно её и просят прислать,
 * когда у человека что-то не работает.
 *
 * ⚠️ ВКЛЮЧАЕТ import.meta.env.DEV, А НЕ ИМЯ ХОСТА. Проверка на localhost
 * выглядела бы разумной и была бы неверна: .exe поднимает игру на
 * http://127.0.0.1:47710, и у КАЖДОГО игрока отладка оказалась бы включена.
 * DEV истинен только под dev-сервером Vite — то есть ровно на машине
 * разработчика и никогда в собранной игре.
 *
 * Включить в собранной игре: в консоли выполнить
 *     localStorage.if_debug = '1'
 * и обновить страницу. Выключить — localStorage.removeItem('if_debug').
 *
 * ⚠️ console.warn И console.error ЗДЕСЬ НИ ПРИ ЧЁМ и глушиться не должны:
 * они про настоящие неполадки, и молчать о них нельзя.
 */
function хочетЛи(): boolean {
  /*
   * ⚠️ ПОД DEV-СЕРВЕРОМ ТЕПЕРЬ ТОЖЕ МОЛЧИМ, И ЭТО ПЕРЕМЕНА ПРЕЖНЕГО РЕШЕНИЯ.
   * Стояло `if (import.meta.env.DEV) return true` — мол, на машине
   * разработчика отладка нужна всегда. На деле выходило иначе: полсотни строк
   * про каждое озеро, каждую рыбу и каждый мегабайт заливали консоль при
   * КАЖДОМ входе, и настоящую ошибку в них было не найти — ровно та беда, от
   * которой этот файл и заводился, только уже на своей стороне.
   *
   * Чистая консоль по умолчанию стоит дороже удобства: в неё смотрят, когда
   * что-то сломалось, и она должна отвечать на вопрос, а не заваливать шумом.
   *
   * Включить — в консоли выполнить `localStorage.if_debug = '1'` и обновить
   * страницу; выключить — `localStorage.removeItem('if_debug')`.
   */
  try {
    return localStorage.getItem('if_debug') === '1';
  } catch {
    // localStorage может быть закрыт настройками приватности — это не повод падать.
    return false;
  }
}

const включено = хочетЛи();

/** Строка в консоль — если отладка включена. Подпись как у console.info. */
export function лог(...части: unknown[]): void {
  if (включено) console.info(...части);
}

/** Включена ли отладка — на случай, если считать саму строку дорого. */
export function отладка(): boolean {
  return включено;
}
